import React from 'react';
import { Route as RRoute, Redirect, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { ApplicationState } from '../stores';
import { PersonRole } from '../models/eums/personRole';

export interface RouteProps {
  path: string;
  exact?: boolean;
  Component: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
  Layout?: React.ComponentType<any>;
  requireAuth?: boolean;
  onlyPublic?: boolean;
  roles?: Array<PersonRole>;
}

function Route({ Component, Layout, requireAuth, onlyPublic, roles, ...rest }: RouteProps) {
  const authenticated = useSelector<ApplicationState, boolean>(state => state.auth.authenticated);
  const personRoles = useSelector<ApplicationState, Array<PersonRole> | undefined>(
    state => state.auth.personRoles,
  );
  const location = useLocation<{
    from?: {
      pathname?: string;
    };
  }>();
  if (requireAuth) {
    if (!authenticated) {
      return <Redirect to={{ pathname: '/login', state: { from: location } }} />;
    }
    if (roles && (!personRoles || !personRoles.some(role => roles.includes(role)))) {
      return <Redirect to='/' />;
    }
  }
  if (onlyPublic && authenticated) {
    const path = location.state?.from?.pathname ?? '/';
    return <Redirect to={path} />;
  }

  const route = <RRoute {...rest} render={props => <Component {...props} />} />;

  if (Layout) {
    return <Layout>{route}</Layout>;
  }
  return route;
}

export default React.memo(Route);
